import { UpdateOp } from './types';

export function mapIf<T>(items: Array<T>, op?: UpdateOp<T>): Array<T> {
  if (op) {
    return items.map(op);
  }

  return items;
}

export default {};
